// The apartment workspace's address: #apartment/<project>/<apartment>. Only ids, never data.

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export interface ApartmentLocation {
  readonly projectId: string;
  readonly apartmentId: string;
}

/** The apartment in a hash such as "#apartment/<p>/<a>"; null when it names none. */
export function parseApartmentLocation(hash: string): ApartmentLocation | null {
  const [section, projectId, apartmentId] = hash.replace(/^#/, '').split('/');
  return section === 'apartment' &&
    projectId !== undefined &&
    apartmentId !== undefined &&
    UUID.test(projectId) &&
    UUID.test(apartmentId)
    ? { projectId, apartmentId }
    : null;
}

export const apartmentHref = (projectId: string, apartmentId: string): string =>
  `#apartment/${projectId}/${apartmentId}`;
